import { render } from "./ChatInputArea.vue?vue&type=template&id=455831e9&scoped=true"
import script from "./ChatInputArea.vue?vue&type=script&lang=js"
export * from "./ChatInputArea.vue?vue&type=script&lang=js"

import "./ChatInputArea.vue?vue&type=style&index=0&id=455831e9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455831e9"]])

export default __exports__